<template>
  <div>
    <shimmer-recommendations
      v-if="!isLocationSettled || isLoadingTopTenBestsellerAPI"
      :type="true"
    />
    <div
      class="hb-top-10 pt10"
      :class="[
        isLeftTitleIconPresent || isHeaderStrokePresent
          ? 'left-view'
          : 'center-view',
        { [modulePropsData.titleClass]: titleClassPresent },
      ]"
      :style="getMainComponentStyle"
      v-else-if="shouldComponentVisible && getDataItems?.length"
    >
      <div
        class="hb-top-10-heading-parent"
        :class="
          isLeftTitleIconPresent
            ? 'flex-row gap12 plr12 align-items-center'
            : 'mb15'
        "
      >
        <div
          :class="
            isLeftTitleIconPresent ? 'flex-column justify-content-end' : 'mb3'
          "
          v-if="isLeftTitleIconPresent || isTopTitleIconPresent"
        >
          <img
            :src="isLeftTitleIconPresent ? leftTitleIcon : topTitleIcon"
            :style="getIconStyle"
          />
        </div>
        <div
          :class="
            isLeftTitleIconPresent || isHeaderStrokePresent ? 'tl pl16' : ''
          "
        >
          <img
            :src="titleImage"
            :style="getTitleImageStyle"
            v-if="isTitleImagePresent && !isLeftTitleIconPresent"
          />
          <span
            class="hb-top-10-heading"
            :class="
              isLeftTitleIconPresent || isHeaderStrokePresent ? 'mb0' : 'mb10'
            "
            :style="getTitleStyle"
            v-else
          >
            {{ modulePropsData?.title }}
            <img :src="headerStroke" v-if="isHeaderStrokePresent" />
          </span>
          <div
            v-if="getUserCity"
            class="flex-row hb-top-10-location-strip"
            :class="
              isLeftTitleIconPresent || isHeaderStrokePresent
                ? 'justify-content-start'
                : 'justify-content-center plr16'
            "
            :style="{
              background:
                !isLeftTitleIconPresent &&
                !isHeaderStrokePresent &&
                getSubtitleBgGradiant,
              height: isLeftTitleIconPresent ? '18px' : '20px',
            }"
          >
            <img
              class="locationIcon"
              :src="modulePropsData?.locationIcon"
              v-if="shouldLocationIconVisible"
            />
            <p class="hb-top-10-subTitle" :style="getSubTitleStyle">
              {{ getUserCity }}
            </p>
          </div>
        </div>
      </div>
      <div :class="eleClassForSlideEffect" class="pb16">
        <Carousel :transition="500" :breakpoints="breakpoints">
          <Slide v-for="(value, index) in getDataItems" :key="index">
            <hongs-product-card
              :data-item="value"
              :data-item-index="index"
              :showFullInfo="true"
              :data-horizontal-carousel="true"
            >
            </hongs-product-card>
          </Slide>
        </Carousel>
      </div>
    </div>
    <!-- Intersection Observer -->
    <Observer :options="{ rootMargin: '-50px' }" @intersect="itisvisible" />
  </div>
</template>

<script>
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide } from "vue3-carousel";
import LocalStorageFunc from "../helpers/localStorageFunc";
import utility from "../helpers/utility.js";
import HongsProductCard from "./HongsProductCard.vue";
import Observer from "./Observer.vue";
import ShimmerRecommendations from "./ShimmerRecommendations.vue";
import { site } from "../config/apiEndpoints.js";
import { keyMapsAction, keyMapsMutation } from "../helpers/storeKeys";
import { getAmplitudeInstance } from "../config/amplitudeKeys.js";
import { DISABLED_ORDER_TYPE } from "../helpers/OrderStatusConstants";

export default {
  name: "HorizontalBannerTopLatest",
  props: ["moduleProps", "dataApi"],
  components: {
    Carousel,
    Slide,
    HongsProductCard,
    Observer,
    ShimmerRecommendations,
  },
  data() {
    return {
      data: {},
      modulePropsData: {},
      itemsToShow: 1.08,
      breakpoints: {
        300: {
          itemsToShow: 1.1,
          snapAlign: "start",
          autoplay: false,
          wrapAround: false,
        },
        380: {
          itemsToShow: 1.09,
          snapAlign: "start",
          autoplay: false,
          wrapAround: false,
        },
      },
      cardSource: "",
      vpsProps: {
        cardRounded: true,
        cardSearchable: false,
        marginGap: true,
        showUpsell: false,
        showCrossell: false,
      },
      topTitleIcon: "",
      locationIcon: "",
      leftTitleIcon: "",
      ribbonTitleIcon: "",
      ribbonTitleColor1: "",
      ribbonTitleColor2: "",
      shouldRibbonVisible: false,
      eleClassForSlideEffect: "",
      isUpdated: false,
      ribbonTitle1: "",
      ribbonTitle2: "",
      shouldLocationIconVisible: false,
      titleImage: "",
      titleClassPresent: false,
      headerStroke: "",
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};

    this.itemsToShow = +this.modulePropsData?.itemsInScreen;
    this.breakpoints = {
      300: {
        itemsToShow: 1.1,
        snapAlign: "start",
        autoplay: false,
        wrapAround: false,
      },
      380: {
        itemsToShow: this.itemsToShow,
        snapAlign: "start",
        autoplay: false,
        wrapAround: false,
      },
    };
    this.cardSource = this.modulePropsData?.title;
    this.topTitleIcon = this.modulePropsData?.titleIconTop;
    this.locationIcon = this.modulePropsData?.locationIcon;
    if (
      this.locationIcon !== undefined &&
      this.locationIcon !== "null" &&
      this.locationIcon !== null &&
      this.locationIcon
    ) {
      this.shouldLocationIconVisible = true;
    }
    this.ribbonTitleIcon = this.modulePropsData?.ribbonIcon;
    if (
      this.ribbonTitleIcon !== undefined &&
      this.ribbonTitleIcon !== "null" &&
      this.ribbonTitleIcon !== null &&
      this.ribbonTitleIcon
    ) {
      this.shouldRibbonVisible = true;
    }
    this.leftTitleIcon = this.modulePropsData?.titleIconLeft;
    this.ribbonTitleColor1 = this.modulePropsData?.ribbonTitleColor1;
    this.ribbonTitleColor2 = this.modulePropsData?.ribbonTitleColor2;
    this.ribbonTitle1 = this.modulePropsData?.ribbonTitle1;
    this.ribbonTitle2 = this.modulePropsData?.ribbonTitle2;
    this.headerStroke = this.modulePropsData?.headerStroke;

    if (
      this.ribbonTitle1 === undefined ||
      this.ribbonTitle1?.toLowerCase() === "null"
    ) {
      this.ribbonTitle1 = "";
    }
    if (
      this.ribbonTitle2 === undefined ||
      this.ribbonTitle2?.toLowerCase() === "null"
    ) {
      this.ribbonTitle2 = "";
    }

    if (
      this.modulePropsData?.animation?.toLowerCase() === "on" &&
      LocalStorageFunc.getAnimationScroll()
    ) {
      this.eleClassForSlideEffect = (
        "_" +
        this.modulePropsData?.title +
        "_" +
        this.modulePropsData?.name
      )
        .replaceAll(" ", "_")
        .trim()
        .toLowerCase();
      LocalStorageFunc.setAnimationScroll(false);
    }

    this.titleImage = this.modulePropsData?.titleImage;
    this.titleClassPresent = !!this.modulePropsData?.titleClass;
    if (LocalStorageFunc.isLoggedIn()) {
      this.$store.dispatch(keyMapsAction.GET_FAVOURITE_IDS_API, {});
    } else {
      this.$store.commit(
        keyMapsMutation.MARK_FAVOURITE_IDS,
        LocalStorageFunc.getFavouriteIds(),
      );
    }
  },
  watch: {
    isUpdated: {
      handler(newVal, oldVal) {
        if (
          newVal === true &&
          this.eleClassForSlideEffect !== undefined &&
          this.eleClassForSlideEffect !== "null" &&
          this.eleClassForSlideEffect != ""
        ) {
          setTimeout(() => {
            document
              .querySelector(
                ".hb-top-10 ." +
                  this.eleClassForSlideEffect +
                  " .carousel__track",
              )
              ?.setAttribute(
                "style",
                "transition:all 500ms ease 0s;transform:translateX(-150px) !important",
              );

            let eleIs = document.querySelector(
              ".hb-top-10 ." +
                this.eleClassForSlideEffect +
                " .carousel__track",
            );
            setTimeout(() => {
              if (eleIs) {
                eleIs.style.transform = "translateX(0px)";
              }
            }, 800);
          }, 500);
        }
      },
    },
  },
  methods: {
    itisvisible() {
      if (!this.isUpdated && this.getDataItems?.length > 0) {
        this.isUpdated = true;
      }
    },
    apiTopTen() {
      let dataApiConstruct =
        this.dataApi?.split("?")[0] ||
        this.modulePropsData?.dataApi?.split("?")[0];
      if (
        dataApiConstruct !== undefined &&
        dataApiConstruct !== null &&
        dataApiConstruct != false
      ) {
        let userFreq = LocalStorageFunc.getUserData()?.userData?.frequency;
        let payloadObj = utility.getQueryFromUrl(
          this.dataApi || this.modulePropsData?.dataApi,
        );
        this.$store.dispatch(keyMapsAction.GET_MULTIPLE_RECOMMENDATION_DATA, {
          api: dataApiConstruct,
          apiPayload: {
            sequenceSet: this.modulePropsData?.sequenceSet || "",
            name: this.modulePropsData?.name || "",
            limit: this.modulePropsData?.limit || "",
            userFrequency: userFreq ? userFreq : "",
            platform: window?._siteProps_?.platform
              ? (window?._siteProps_?.platform).toLowerCase() === "web"
                ? "dt"
                : window?._siteProps_?.platform.toLowerCase()
              : "pwa",
            site: site,
          },
          payloadObj,
        });
      }
    },
    titleCase(str) {
      var splitStr = str.toLowerCase().split(" ");
      for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] =
          splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      return splitStr.join(" ");
    },
    processResultDataForStore(data) {
      this.$store.commit(keyMapsMutation.UPDATE_PRODUCTS_IN_STORE, data);
      this.$store.commit(keyMapsMutation.LOAD_CART_FROM_STORAGE_SERVICE, data);
    },
    getImageUrl(productItem) {
      let mediaBaseUrl = this.$store.state.ProductItems.imgBaseUrl;
      return utility.getHomeProductImage(
        productItem,
        mediaBaseUrl,
        staticImgBaseUrl,
      );
    },
    isItemDisabled(productItem) {
      let deliveryType = LocalStorageFunc.getDeliveryType();
      let isItemDisabled = false;
      productItem?.disabledOrderTypes.map((x) => {
        if (DISABLED_ORDER_TYPE[x] === deliveryType) isItemDisabled = true;
      });
      productItem?.variants &&
        productItem?.variants.map((i) =>
          i.disabledOrderTypes.map((x) => {
            if (DISABLED_ORDER_TYPE[x] === deliveryType) isItemDisabled = true;
          }),
        );
      return isItemDisabled;
    },
  },
  computed: {
    getDataItems() {
      const { name, sequenceSet } = this.modulePropsData;
      let key = name ? name : "";
      if (sequenceSet) {
        key = key + "_" + sequenceSet;
      }
      this.data = this.$store.state.MultipleRecommendation[key] || {};
      // if (JSON.stringify(this.$store.state.ProductItems.products) === "{}")
      //   this.processResultDataForStore(this.data);
      let top10Ids = this.data?.skuIds;
      let productCategoryMap =
        this.$store.state.ProductItems.productCategoryMap;
      let products = this.$store.state.ProductItems.products;
      let res = {};
      let top10data = [];
      Object.keys(productCategoryMap).map((_) => {
        res[_] = products[Object.keys(productCategoryMap[_])?.[0]]?.[_];
      });
      top10Ids &&
        top10Ids.length &&
        top10Ids.map((x) => top10data.push(res[x]));
      // Object.keys(res).map((_) => {
      //   if (top10Ids.includes(_)) {
      //     top10data[_] = res[_];
      //   }
      // });
      return top10data.filter((x) => !this.isItemDisabled(x));
    },

    getTitleStyle() {
      let _;
      let color1 = this.modulePropsData?.titleColor1;
      let color2 = this.modulePropsData?.titleColor2;

      if (color1 && color2 && color1 !== "null" && color2 !== "null") {
        _ = {
          background:
            "linear-gradient(160.86deg, " +
            this.modulePropsData?.titleColor1 +
            " 4.88%, " +
            this.modulePropsData?.titleColor2 +
            " 71.26%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
          textFillColor: "trasparent",
        };
      } else {
        _ = {
          color: color1 || color2,
        };
      }

      return _;
    },

    getComponentBgColor() {
      let _;
      if (
        this.modulePropsData?.backgroundImage !== undefined &&
        this.modulePropsData?.backgroundImage !== null &&
        this.modulePropsData?.backgroundImage !== "null"
      ) {
        _ = this.modulePropsData?.backgroundImage;
      } else {
        // _ =
        //   "linear-gradient(180deg, " +
        //   this.modulePropsData?.bgGradientColor1 +
        //   "33" +
        //   " 0%, " +
        //   this.modulePropsData?.bgGradientColor2 +
        //   "6B" +
        //   " 51.56%, " +
        //   this.modulePropsData?.bgGradientColor3 +
        //   "00" +
        //   " 100%)";
        _ = this.modulePropsData?.bgGradientColor1;
      }
      return _;
    },

    getMainComponentStyle() {
      let background = this.getComponentBgColor;
      let borderTop = this.modulePropsData?.topBorder;
      let borderBottom = this.modulePropsData?.bottomBorder;
      let borderColor = this.modulePropsData?.borderColor;
      if (
        borderColor === undefined ||
        borderColor === "null" ||
        borderColor === null ||
        !borderColor
      ) {
        borderColor = "#f1f1f1";
      }

      let bgRelatedProperty = {
        background: background,
      };

      if (background?.includes("http")) {
        if (this.isLeftTitleIconPresent) {
          bgRelatedProperty = {
            background: `left/cover no-repeat url(${background})`,
          };
        } else {
          bgRelatedProperty = {
            background: `center/cover url(${background})`,
            backgroundRepeat: `no-repeat`,
          };
        }
      }

      let _ = {
        ...bgRelatedProperty,
        borderTop: borderTop ? borderTop + "px solid" : 0,
        borderBottom: borderBottom ? borderBottom + "px solid" : 0,
        borderColor: borderColor,
      };

      return _;
    },

    getSubtitleBgGradiant() {
      let _ =
        "linear-gradient(270.02deg, " +
        this.modulePropsData?.subTitleGradientColor1 +
        "00" +
        " 0.02%, " +
        this.modulePropsData?.subTitleGradientColor2 +
        " 49.58%, " +
        this.modulePropsData?.subTitleGradientColor3 +
        "00" +
        " 97.13%)";
      return _;
    },

    getSubTitleStyle() {
      let color1 = this.modulePropsData?.subTitleColor1;
      let color2 = this.modulePropsData?.subTitleColor2;

      let _;
      if (color1 && color2 && color1 !== "null" && color2 !== "null") {
        _ = {
          background:
            "linear-gradient(160.86deg, " +
            this.modulePropsData?.subTitleColor1 +
            " 4.88%, " +
            this.modulePropsData?.subTitleColor2 +
            " 71.26%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
          textFillColor: "trasparent",
        };
      } else {
        _ = {
          color: color1 || color2,
        };
      }
      return _;
    },
    isHeaderStrokePresent() {
      if (
        this.modulePropsData?.titleAlignment?.toLowerCase() === "left" &&
        this.headerStroke !== undefined &&
        this.headerStroke !== null &&
        this.headerStroke !== "null"
      ) {
        return true;
      } else {
        return false;
      }
    },
    isLeftTitleIconPresent() {
      if (
        this.modulePropsData?.titleAlignment?.toLowerCase() === "left" &&
        this.leftTitleIcon !== undefined &&
        this.leftTitleIcon !== null &&
        this.leftTitleIcon !== "null"
      ) {
        return true;
      } else {
        return false;
      }
    },
    isTopTitleIconPresent() {
      if (
        this.topTitleIcon !== undefined &&
        this.topTitleIcon !== null &&
        this.topTitleIcon !== "null"
      ) {
        return true;
      } else {
        return false;
      }
    },
    getUserCity() {
      // let { city } = this.$store.state.Location.storeDetails;
      // let subTitle = this.modulePropsData?.subTitle;
      let defaultSubTitle = this.modulePropsData?.defaultSubtitle;
      // let userName = LocalStorageFunc.getUserData()?.userData?.firstName;

      // if (
      //   subTitle !== undefined &&
      //   subTitle !== null &&
      //   subTitle !== "null" &&
      //   subTitle
      // ) {
      //   if (
      //     subTitle?.includes(":locationName") &&
      //     city !== undefined &&
      //     city !== null &&
      //     city
      //   ) {
      //     return "In " + this.titleCase(city);
      //   } else if (
      //     subTitle?.includes(":userName") &&
      //     LocalStorageFunc.isLoggedIn() &&
      //     userName
      //   ) {
      //     return subTitle?.replace(":userName", userName);
      //   } else {
      //     return defaultSubTitle;
      //   }
      // } else {
      //   return defaultSubTitle;
      // }
      return defaultSubTitle;
    },

    shouldComponentVisible() {
      let userProperty = this.modulePropsData?.userSupportType;
      let validOptions = userProperty ? userProperty?.split("$") : [];
      let userFrequency = LocalStorageFunc.getUserData()?.userData?.frequency;
      let isUserLoggedIn = LocalStorageFunc.isLoggedIn();
      let optionPresent = [];

      if (!isUserLoggedIn) {
        optionPresent.push("NL");
      }

      if (
        userFrequency !== undefined &&
        userFrequency !== null &&
        userFrequency != ""
      ) {
        optionPresent.push(userFrequency);
      }

      // if(this.previousOrderPizzaLength === 0 && isUserLoggedIn){
      //   optionPresent.push('N');
      // }else if(this.previousOrderPizzaLength === 1){
      //   optionPresent.push('S')
      // }

      const matchFound = validOptions.some(
        (r) => optionPresent.indexOf(r) >= 0,
      );

      const moduleNameString =
        "NGH_MODULE_" +
        this.modulePropsData?.title?.trim()?.toUpperCase().replaceAll(" ", "_");

      getAmplitudeInstance().setUserProperties({
        [moduleNameString]:
          matchFound && this.getDataItems?.length ? "visible" : "not visible",
      });

      return matchFound;
    },
    isLocationSettled() {
      let _ = this.$store.state.Location.isLocationSettled;
      if (_) {
        this.apiTopTen();
      }
      return _;
    },
    isLoadingTopTenBestsellerAPI() {
      return this.$store.state.MultipleRecommendation
        .isLoadingTopTenBestsellerAPI;
    },
    previousOrderPizzaLength() {
      return this.$store.state.ReOrder.previousOrderData?.length;
    },
    getIconStyle() {
      let maxHeight = this.modulePropsData?.iconMaxHeight;
      let _ = {
        maxHeight: maxHeight + "px !important",
      };

      return _;
    },
    isTitleImagePresent() {
      if (
        this.modulePropsData?.titleImage !== undefined &&
        this.modulePropsData?.titleImage !== null &&
        this.modulePropsData?.titleImage !== "null"
      ) {
        return true;
      } else {
        return false;
      }
    },
    getTitleImageStyle() {
      let maxHeight = this.modulePropsData?.titleImageMaxHeight;
      let _ = {
        maxHeight: maxHeight + "px !important",
      };
      return _;
    },
  },
};
</script>

<style scoped></style>
